import { BaseApi } from './base.api.js';

export class FormSubmissionApi extends BaseApi {
    constructor(client) {
        super(client, '/form-submission');
    }

    async getSurveyResponses(params = {}) {
        const response = await this.client.get(`${this.basePath}/survey-responses`, { params });
        return response.data;
    }

    async getSurveyResponseById(id) {
        const response = await this.client.get(`${this.basePath}/survey-responses/${id}`);
        return response.data;
    }

    async submit(data) {
        const response = await this.client.post(`${this.basePath}/submit`, data);
        return response.data;
    }
}
